// extracted by mini-css-extract-plugin
export default {"left":"a1C2F","external":"b1C2F","center":"c1C2F","right":"d1C2F"};